export default __webpack_public_path__ + "static/media/billy-on-rocket.033e1719.png";